import { useNavigate, Link } from 'react-router-dom'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { AuthLayout } from '@/layout/AuthLayout'
import { SignInForm } from '@/components/SignInForm'

export function SignIn() {
  const navigate = useNavigate()

  const handleSuccess = () => {
    navigate('/')
  }

  return (
    <AuthLayout>
      <Card className="border-0 shadow-none">
        <CardHeader className="pb-4">
          <CardTitle className="gradient-text py-4 text-4xl">Sign In</CardTitle>
          <CardDescription className="text-xs text-muted-foreground">
            New User?{' '}
            <Link
              to="/auth/signup"
              className="text-primary hover:underline"
            >
              Create an account
            </Link>
          </CardDescription>
        </CardHeader>
        <CardContent className="pt-0">
          <SignInForm onSuccess={handleSuccess} showLinks={true} />
        </CardContent>
      </Card>
    </AuthLayout>
  )
}
